// extracted by mini-css-extract-plugin
export var container = "ResultsCount-module--container--fa543";
export var resultCount = "ResultsCount-module--resultCount--09ba1";
export var resultsCountContainer = "ResultsCount-module--resultsCountContainer--5eadc";
export var resultsFor = "ResultsCount-module--resultsFor--0464c";